import { dateParser } from '@feat/feat-url-state/date'
import { endOfDayInDefaultTimeZone, startOfDayInDefaultTimeZone } from '@utils/helpers'
import type { ExperienceFilter } from './experience-state-types'

/** A from-only selection is one day, on both sides of the hydration boundary. */
export function normalizeExperienceInterval({ from, to }: ExperienceFilter) {
  const effectiveTo = from && to && to < from ? null : to
  return {
    from: from && startOfDayInDefaultTimeZone(from),
    to: effectiveTo ?? (from && endOfDayInDefaultTimeZone(from)),
  }
}

export function serializeExperienceInterval(filter: ExperienceFilter) {
  const { from, to } = normalizeExperienceInterval(filter)
  return {
    from: from ? dateParser.from.serialize(from) : undefined,
    to: to ? dateParser.to.serialize(to) : undefined,
  }
}

export function displayedDateRange(dates: readonly { date: string }[]) {
  const days = dates.map(item => item.date).toSorted()
  return days.length === 0 ? null : { from: days[0], to: days[days.length - 1] }
}

const pad = (value: number) => String(value).padStart(2, '0')

export function monthAround(day: string): { from: string; to: string } {
  const [year, month] = day.split('-').map(Number)
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate()
  return { from: `${year}-${pad(month)}-01`, to: `${year}-${pad(month)}-${pad(lastDay)}` }
}
